import { useTranslation } from '@thoughtspot/i18n';
import { Icon, IconColor, IconID, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, View, } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { SearchBar } from '@thoughtspot/radiant-react/widgets/search-bar';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import { TranslationsKeys } from '../util';
import styles from './add-users-to-org-modal.module.scss';
export const AddUsersToOrgModal = ({ onAddUsersToOrgConfirm, onAddUsersToOrgModalClose, isModalOpen, orgList = [], updateOrgListPayload, showLoader = false, setSelectedOrg, selectedOrg, }) => {
    const { t } = useTranslation();
    const renderOrgSelectList = (listData, isSearchIncluded = false, setSearchTerm) => {
        const hasOrgSelected = (listItemId) => listItemId === selectedOrg;
        const orgItemIcon = (listItem) => {
            if (hasOrgSelected(listItem.orgId)) {
                return (React.createElement(Icon, { id: IconID.CHECKMARK, color: IconColor.BLUE, "data-testid": "org-item-checkmark" }));
            }
            return React.createElement(React.Fragment, null);
        };
        const onClickOrg = (listItem) => {
            setSelectedOrg(listItem.orgId);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Vertical, { spacing: "a", className: styles.orgListTopContainer },
                isSearchIncluded && (React.createElement(SearchBar, { searchValue: "", searchPlaceholder: t('cirrus.metadata.search.placeHolder'), onSearchChange: (searchTerm) => {
                        setSearchTerm(searchTerm);
                    }, "data-testid": "search-bar-filters" })),
                React.createElement(Horizontal, { className: styles.orgListHeader },
                    React.createElement(Typography, { variant: "caption", overrideTag: "div", color: Colors.base }, `${t(TranslationsKeys.SELECTED_ORGS)}`))),
            React.createElement(Vertical, { className: styles.orgListContainer },
                React.createElement(LoadingIndicator.Global, { hideLoader: !showLoader },
                    React.createElement(Vertical, { className: styles.orgList }, listData.map((item) => (React.createElement(Horizontal, { shrink: 0, grow: 0, key: item.orgId, role: "none", tabIndex: 0, className: cx(styles.orgItem, {
                            [styles.itemSelected]: hasOrgSelected(item.orgId),
                        }), onClick: () => {
                            onClickOrg(item);
                        }, onKeyDown: e => {
                            if (e.key === 'Enter') {
                                onClickOrg(item);
                            }
                        }, "data-testid": "org-list-item" },
                        React.createElement(Typography, { variant: "body-normal", noMargin: true, className: styles.orgName, overrideTag: "span" }, item.orgName),
                        React.createElement(View, { className: styles.orgIcon }, orgItemIcon(item))))))))));
    };
    return (React.createElement(Modal, { className: styles.modal, size: ModalSize.SMALL, title: t(TranslationsKeys.ADD_USERS_TO_ORG), isOpen: isModalOpen, confirmButton: {
            text: t(TranslationsKeys.ADD),
            onConfirm: () => {
                onAddUsersToOrgConfirm(selectedOrg);
            },
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onAddUsersToOrgModalClose },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement("div", { "data-testid": "add-users-to-org-confirmation-body" }, renderOrgSelectList(orgList, true, updateOrgListPayload)))));
};
//# sourceMappingURL=add-users-to-org-modal.js.map